import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);
    return(
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '90vh'
            }}
        >
            <Typography variant="h1"> 404 </Typography>
            <Typography variant="h5">
                La página no existe.
            </Typography> <br />
            <Button variant="contained" onClick={goBack}>Regresar</Button>
        </Box>
    )
}

export default PageNotFound;